export default "__VITE_ASSET__D_Su0obz__"